module.exports = __webpack_public_path__ + "static/img/index_item02.e54faaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_item02.png
// module id = LLVh
// module chunks = 0